<h1 mat-dialog-title>Team memberships</h1>

<div mat-dialog-content class="dialog-content">
  <div class="user-summary">
    <div class="user-name">{{data.user.firstName}} {{data.user.lastName}}</div>
    <div class="user-email">{{data.user.email || '-'}}</div>
  </div>

  <div *ngIf="loading" class="state-message">Loading team memberships...</div>
  <div *ngIf="errorMessage" class="state-message error">{{errorMessage}}</div>
  <div *ngIf="!loading && !errorMessage && memberships.length === 0" class="state-message">
    No active team memberships.
  </div>

  <table
    mat-table
    [dataSource]="memberships"
    class="memberships-table"
    *ngIf="!loading && !errorMessage && memberships.length > 0"
  >
    <ng-container matColumnDef="team">
      <th mat-header-cell *matHeaderCellDef>Team</th>
      <td mat-cell *matCellDef="let membership">{{membership.teamName}}</td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef>Company</th>
      <td mat-cell *matCellDef="let membership">{{membership.companyName || 'Not associated'}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Done</button>
</div>
